import { createSwitchStore } from '@/stores/createSwitchStore';

export const useCurrentProjectSwitchStore = createSwitchStore('user/project/switch');
export const useUserSwitchStore = createSwitchStore('user/switch');
